import React, { useEffect, useState, useCallback } from 'react';

const AnimatedPopup = ({ gifUrl, messages, onClose, displayDuration = 4000 }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  // Memoize handleClose to prevent unnecessary re-renders
  const handleClose = useCallback(() => {
    setIsClosing(true);
    // Wait for animation to complete before calling onClose
    setTimeout(() => {
      onClose();
    }, 300); // Match the duration of the fadeOut animation
  }, [onClose]);

  useEffect(() => {
    if (!gifUrl) {
      setIsLoaded(true);
      return;
    }

    // Preload the GIF
    const img = new Image();
    img.onload = () => {
      setIsLoaded(true);
      
      // Auto-close popup after specified duration
      const timeoutId = setTimeout(() => {
        handleClose();
      }, displayDuration);
      
      return () => clearTimeout(timeoutId);
    };
    
    img.onerror = () => {
      console.error('Error loading GIF');
      handleClose();
    };
    
    img.src = gifUrl;
    
    // Cancel timeout if component unmounts
    return () => {
      img.onload = null;
      img.onerror = null;
    };
  }, [gifUrl, handleClose, displayDuration]);

  // Convert messages prop to array if it's a string
  const textMessages = Array.isArray(messages) 
    ? messages 
    : messages 
      ? [messages] 
      : ["Loading", "Please wait", "Almost there", "Done!"];

  return (
    <div className={`popup-overlay ${isClosing ? 'closing' : ''}`} onClick={handleClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        {gifUrl && (
          <div className="animated-gif">
            <img 
              src={gifUrl} 
              alt="Animation" 
              className={`gif-image ${isLoaded ? 'heartbeat' : ''}`}
              style={{ opacity: isLoaded ? 1 : 0.5 }}
            />
          </div>
        )}
      </div>
      <div className="dropping-texts-container">
          <div className="dropping-texts">
            {textMessages.map((text, index) => (
              <div 
                key={index}
                className="text-item"
                style={{
                  animationDelay: `${index * 1.2}s`,
                  animationDuration: `${textMessages.length * 1.2}s`
                }}
              >
                {text}
              </div>
            ))}
          </div>
        </div>
    </div>
  );
};

export default AnimatedPopup;